'use client';

import { BotOff } from 'lucide-react';

import { Tooltip } from './tooltip';
import { cn } from '../utils/cn';

interface AgentNotReadableBadgeProps {
	/** Visual size in pixels (icon + frame). Defaults to 16. */
	size?: number;
	className?: string;
}

const TOOLTIP_TEXT =
	"Naumu can't read this file - it's uploaded for sharing only.";

export const AgentNotReadableBadge = ({
	size = 16,
	className,
}: AgentNotReadableBadgeProps) => {
	const iconSize = Math.round(size * 0.75);
	return (
		<Tooltip content={TOOLTIP_TEXT}>
			<span
				role="img"
				aria-label={TOOLTIP_TEXT}
				style={{ width: size, height: size }}
				className={cn(
					'inline-flex items-center justify-center rounded-full bg-overlay text-neutral-weak',
					'border border-solid border-border-weak',
					className,
				)}
			>
				<BotOff style={{ width: iconSize, height: iconSize }} strokeWidth={2} />
			</span>
		</Tooltip>
	);
};
